import { FloraButton } from '@grupoboticario/flora-react';
import { app } from 'core';
import { Link } from 'react-router';
import slugify from 'slugify';
import { ResponsiveFloraTypography } from 'ui/components/primitives/ResponsiveFloraTypography';

import Styles from './HeadingWithButton.styles';

export const HeadingWithButton = ({ title, link }: { title: string; link?: string }) => {
  const { trackClick } = app.commands.useAppCommand();

  const handleButtonInteraction = () => {
    trackClick({
      event: 'analytics-event',
      event_parameters: {
        event_name: `interaction_${slugify(title, {
          lower: true,
          replacement: '_',
        })}`,
        cd_interaction_detail: 'click:ver-tudo:top',
        cd_section: slugify(title, { lower: true }),
      },
    });
  };

  return (
    <Styles.TitleWrapper align="center">
      <ResponsiveFloraTypography fontSize="subtitle" fontWeight="medium" as="h2">
        {title}
      </ResponsiveFloraTypography>

      {link && (
        <FloraButton
          type="button"
          as={Link}
          onClick={handleButtonInteraction}
          size="small"
          hierarchy="secondary"
          to={encodeURI(link)}
          aria-label={`ver tudo de ${title || ''}`}
          role="button"
        >
          Ver tudo
        </FloraButton>
      )}
    </Styles.TitleWrapper>
  );
};
